exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-editor {\n  display: grid;\n  grid-gap: 2rem;\n}", ""]);

// exports
